import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { _Api } from "../../api/_call";
import {
  LocationList,
  SupplierList,
  VoucherList,
} from "../../common/graphql/commonlayouts";
import './createpoReplenishOrder.scss';

import TableColumnModal from "../../common/modules/tableColumn";
import ConfirmationModel from "../../common/modules/confirmationmodel";
import Advancedfiltermodel from "../../common/modules/advanced-filter-model";
import NotesModalLabel from "../../common/modules/NotesModalLabel";
import { calDuedate } from "../../common/helpers/formatDate";
import Select from "react-select";
import { toFormatPrice, toUnformatPrice } from "../../common/helpers/function";
import { error, loading, Updateloading } from "../../common/helpers/toastify";
import { createpotablehead } from "../../common/Tablehead";
import TransAndDeliverDate from "../../common/modules/TransAndDeliverDate";
import SocialModal from "../../common/modules/SocialModal/SocialModal";

// Column order mirrors createpotablehead — index-aligned so a column's
// sort key / visibility can be looked up by its position.
const SORT_KEYS = [
  null, null, null, "sku", "date", "pos_no", "stock_id",
  null, null, null, "qty", "price", "amount", "ship_to",
  "customer", "delivery_date",
];
const SORT_ACCESSORS = {
  sku: (r) => r?.product_details?.SKU,
  date: (r) => r?.createdAt,
  pos_no: (r) => r?.pos?.ref,
  stock_id: (r) => r?.stock_id,
  qty: (r) => Number(r?.Qty) || 0,
  price: (r) => Number(toUnformatPrice(r?.price)) || 0,
  amount: (r) => (Number(r?.Qty) || 0) * (Number(toUnformatPrice(r?.price)) || 0),
  ship_to: (r) => r?.location_name,
  customer: (r) => r?.customer_name,
  delivery_date: (r) => r?.delivery_date,
};

const CreatePO = (props) => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const base_url = process.env.REACT_APP_BASE_ASSETS_URL;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [form_note, setForm_note] = useState(null);
  const [commanSelected_loc, setcommanSelected_loc] = useState(null);
  const [commanSelected_sup, setcommanSelected_sup] = useState(null);
  const [commanSelected_vouc, setcommanSelected_vouc] = useState(null);
  const [PO_OrdersList, setPO_OrdersList] = useState([]);
  const [TransactionDate, setTransactionDate] = useState(new Date());
  const [DeliveryDate, setDeliveryDate] = useState();
  const [newcolumndata, setnewcolumndata] = useState(createpotablehead);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [selecteditem, setSelecteditem] = useState([]);
  const [SelectAllStatus, setSelectAllStatus] = useState();
  const [poExportFormat, setPoExportFormat] = useState("xlsx");
  const [limit, setLimit] = useState(100);
  const [filtername, setFiltername] = useState('');
  const [ShowProductSearchBar, setShowProductSearchBar] = useState(false);
  const productSearchBar = useRef(null);
  const searchDebounceRef = useRef(null);
  const filternameRef = useRef(filtername);
  filternameRef.current = filtername;
  // const [pos, setPos] = useState()
  const getdeliverydate = async () => {
    setDeliveryDate(await calDuedate(new Date()));
  }
  useEffect(() => {
    getdeliverydate();
  }, []);

  
  const handleClickOutside = (event) => {
    // if (inputRef.current && !inputRef.current.contains(event.target)) {
    //   setIsInputVisible(false);
    // }
    if (productSearchBar.current && !productSearchBar.current.contains(event.target)) {
      setShowProductSearchBar(false);
    }
    // if (closeEditColumns.current && !closeEditColumns.current.contains(event.target)) {
    //   setShowEditColumns(false);
    // }
    // if (secondRowOption.current && !secondRowOption.current.contains(event.target)) {
    //   setIsOpen(false);
    // }

  }

  useEffect(() => {
    return () => {
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
        }
    };
}, []);

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]

  let mapChange_handle = (i, value, type) => {
    let data = [...PO_OrdersList];
    data[i][type] = value;
    setPO_OrdersList(data);
  };
  // Custom client-side sorting (replaces jQuery DataTables sorting).
  const handleSort = (key) => {
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: "asc" }
    );
  };
  const sortedList = useMemo(() => {
    const accessor = SORT_ACCESSORS[sortConfig.key];
    if (!accessor) return PO_OrdersList;
    const sorted = [...PO_OrdersList].sort((a, b) => {
      const av = accessor(a);
      const bv = accessor(b);
      if (av === undefined || av === null) return 1;
      if (bv === undefined || bv === null) return -1;
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av).localeCompare(String(bv), undefined, { numeric: true });
    });
    return sortConfig.direction === "asc" ? sorted : sorted.reverse();
  }, [PO_OrdersList, sortConfig]);
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_po_createpo",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const po_create_submit = async () => {
    try {
      if (!commanSelected_vouc) {
        error(t("Please select voucher"));
        return;
      }
      if (!commanSelected_loc) {
        error(t("Please select location"));
        return;
      }
      if (!TransactionDate) {
        error(t("Please select Transaction Date"));
        return;
      }
      if (!DeliveryDate) {
        error(t("Please select Delivery Date"));
        return;
      }
      var checkedValue = document.querySelectorAll(".PO_OrdersList:checked");
      var product_data = [];
      var posdata;
      checkedValue.forEach(function (result) {
        var i = result.getAttribute("data-key");
        var product_details = PO_OrdersList[i]["product_details"];
        var order_type=PO_OrdersList[i]['pos']['order_type']
        product_data.push({
          repair_connect_po_product_id:order_type==="repair_order"?product_details['repair_connect_po_product_id']:"",
          product_id: product_details["product_id"],
          oldStock_id: "",
          customer_id:
            PO_OrdersList[i]["Customer_id"] ||
            PO_OrdersList[i]["customer_id"] ||
            PO_OrdersList[i]?.pos?.customer_id ||
            "",
          so_no: PO_OrdersList[i]["So_No"],
          po_QTY: parseInt(PO_OrdersList[i]["Qty"]),
          price: toFormatPrice(PO_OrdersList[i]["price"]),
          amount_total: toFormatPrice(PO_OrdersList[i]["price"] * parseInt(PO_OrdersList[i]["Qty"])),
          sales_order_id: PO_OrdersList[i]["id"],
          remark: "",
          Style: product_details["Style"],
          Metal: product_details["Metal"],
          Color: product_details["Color"],
          Size: product_details["Size"],
          Unit: product_details["Unit"],
          GrossWt: product_details["GrossWt"],
          NetWt: product_details["NetWt"],
          Stone: product_details["Stone"],
          StoneGroup: product_details["StoneGroup"],
          StoneVariant: product_details["StoneVariant"],
          StoneShape: product_details["StoneShape"],
          Pcs: product_details["Pcs"],
          WeightType: product_details["WeightType"],
          StoneCut: product_details["StoneCut"],
          StoneClarity: product_details["StoneClarity"],
          StoneColor: product_details["StoneColor"],
          stoneSize: product_details["stoneSize"],
          certificate: product_details["certificate"],
          Certificatetype: product_details["Certificatetype"],
          certificateNo: product_details["certificateNo"],
          Weight: product_details["Weight"],
          Stones: product_details["Stones"],
          pos: PO_OrdersList[i]["pos"]
        });
        posdata = PO_OrdersList[i]["pos"]
      });
      if (!product_data.length) {
        error(t("No item Selected!!"));
        return;
      }
      const postdata = {
        voucher_id: commanSelected_vouc,
        location_id: commanSelected_loc,
        supplier_id: commanSelected_sup,
        delivery_date: DeliveryDate,
        transaction_date: TransactionDate,
        note: form_note,
        type: "POS_Order",
        po_data: product_data,
        RefNo: '',
        pos: posdata
      };
      let GetloadingID = loading();
      try {
        let resPoOrders = await _Api(postdata, `api/v1/Inventory/po/createPO`);
        if (resPoOrders.code === 200) {
          Updateloading(t, GetloadingID, t("Added successfully!!"));
          const timer = setTimeout(() => {
            navigate("/app/inventory");
          }, 1000);
          return () => clearTimeout(timer);
        } else {
          Updateloading(
            t,
            GetloadingID,
            resPoOrders.errors || resPoOrders?.message || t("Something went wrong"),
            "error"
          );
        }
      } catch (err) {
        Updateloading(t, GetloadingID, t("Something went wrong"), "error");
      }
    } catch (err) { }
  };
  const posorders_idshave = useCallback(async (search = filternameRef.current) => {
    try {
      const postdata = {
        search: search ? search : "",
        cart_id: state ? state?.createlist : "",
        ship_to: commanSelected_loc
          ? commanSelected_loc
          : state
            ? state?.hidelocationid
            : "",
      };
      let resPoOrders = await _Api(
        postdata,
        `api/v1/Inventory/po/getPOSDetails`
      );
      if (resPoOrders.code === 200) {
        setPO_OrdersList(resPoOrders?.data);
        resPoOrders.data.forEach((result) => {
          setcommanSelected_loc(result?.location_id);
        });
      } else if (resPoOrders.code === 400) {
        error(resPoOrders?.errors?.ship_to?.[0]);
        return;
      }
    } catch (err) {
      console.log(err, "err");
    }
  }, [state, commanSelected_loc]);

  const scheduleSearch = useCallback(
    (search, delay = 300) => {
      if (searchDebounceRef.current) {
        clearTimeout(searchDebounceRef.current);
      }
      searchDebounceRef.current = setTimeout(() => {
        posorders_idshave(search);
      }, delay);
    },
    [posorders_idshave]
  );

  const handleFilterNameChange = (value) => {
    setFiltername(value);
    scheduleSearch(value);
  };

  const applySearchNow = (search = filternameRef.current) => {
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }
    setFiltername(search);
    posorders_idshave(search);
  };

  useEffect(() => {
    if (!state) {
      // if (commanSelected_loc && commanSelected_sup) {
        if (commanSelected_loc) {
        posorders_idshave();
      }
    } else {
      posorders_idshave();
    }
  }, [commanSelected_loc, 
    // commanSelected_sup,
     state, posorders_idshave]);
  useEffect(() => {
    callcolumns();
  }, []);
  const deleteProduct = () => {
    const selected = document.querySelectorAll(".PO_OrdersList");
    for (let i = 0; i < selected.length; i++) {
      if (selected[i].checked) {
        let product_id = selected[i].getAttribute('data-id');
        setPO_OrdersList((current) =>
          current.filter((item) => item?.id !== product_id)
        );
        setSelecteditem((current) =>
          current.filter((item) => item !== product_id)
        );
        selected[i].checked = false;
      }
    }
  }
  const handleSelectAllCheckBox = (event) => {
    const isChecked = event.target.checked;
    document.querySelectorAll(".posordertableHead").forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
    setSelectAllStatus(isChecked);
  };
  const selectedproduct = (event) => {
    if (event.target.checked) {
      const mainselected = [...selecteditem, event.target.value];
      setSelecteditem(mainselected);
    } else {
      const result = selecteditem.filter((element) => {
        return element !== event.target.value;
      });
      setSelecteditem(result);
    }
  }
  useEffect(() => {
    if (SelectAllStatus) {
      const selected = document.querySelectorAll(".PO_OrdersList");
      let arrya = [];
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].checked) {
          let product_id = selected[i].getAttribute('value');
          arrya.push(product_id);
        }
      }
      setSelecteditem(arrya);
    } else {
      setSelecteditem([]);
    }
  }, [SelectAllStatus]);
  const downloadexclsheet = async (format = poExportFormat) => {
    const handleValidation = (e) => {
      let formIsValid = true
      if (!commanSelected_loc) {
        formIsValid = false
        error(t("Please select location"));
        return;
      }
      return formIsValid
    }
    if (handleValidation()) {
      let GetloadingID = loading();
      try {
        let postdata = {
          "ship_to": commanSelected_loc,
          format: format || "xlsx",
        }
        let res = await _Api(postdata, "api/v1/Inventory/po/getPOSOrderListExportByLocation")
        if (res?.code === 200) {
          Updateloading(t, GetloadingID, (res?.message));
        } else {
          Updateloading(t, GetloadingID, (res.errors), 'error');
        }
      }
      catch (err) {
        console.log(err, "err")
      }
    }
  }

  return (
    <React.Fragment>
      <div className="main-body" style={{paddingTop: "0px"}}>
      <div className="create-po-sticky-header">
        <div className="row" id="new-brandcumcategory">
          <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
            <div className="main-content-wrapper-body-top-bar-left">
              <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
                {t("Transaction")} <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 5L13 10L8 15" stroke="#A0A0A0" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>{t("Create Purchase Order")}</span>
              </h1>
            </div>
          </div>
        </div>
        <div className="container" id="style-create-po-page">
          <div className="row">
            <div className="col-lg-12">
              <div className="top-heading-area">
                <div className="top-heading-area-left">
                  <Link to="/app/inventory" className="page-back-btn">
                    <img
                      src={base_url + "images/icons/arrow-left.png"}
                      alt=""
                    />
                  </Link>
                  <img src={base_url + "images/icons/home-icon.png"} alt="" />
                  <VoucherList
                    setcommanSelected_vouc={setcommanSelected_vouc}
                    group={"Purchase_order"}
                  ></VoucherList>
                </div>

              </div>
              <div className="main-body-top-tab-bar create-purchase-top-bar">
                <div
                  className="main-body-top-tab-bar-left-col nav nav-pills"
                  role="tablist"
                >
                  <Link
                    to="/app/inventory/createpo"
                    className="main-body-top-tab-bar-left-col-a nav-link active tab-hover table-refresh"
                  >
                    <span className="main-body-top-tab-bar-left-col-a-text">
                      <img
                        className="tab-hover-img-1"
                        src={base_url + "images/icons/price-list-icon.png"}
                        alt=""
                      />
                      <img
                        className="tab-hover-img-2"
                        src={
                          base_url + "images/icons/price-list-icon-green.png"
                        }
                        alt=""
                      />
                      {t("POS Order")}
                    </span>
                  </Link>
                  {state ? !state.createlist ?
                    <>
                      <Link
                        to="/app/inventory/createpoReplenishOrder"
                        className="main-body-top-tab-bar-left-col-a nav-link tab-hover table-refresh"
                      >
                        <span className="main-body-top-tab-bar-left-col-a-text">
                          <img
                            className="tab-hover-img-1"
                            src={base_url + "images/icons/replenish-icon.png"}
                            alt=""
                          />
                          <img
                            className="tab-hover-img-2"
                            src={base_url + "images/icons/replenish-icon-green.png"}
                            alt=""
                          />
                          {t("Replenish Order")}
                        </span>
                      </Link>
                      <Link
                        to="/app/inventory/createPOReworkOrder"
                        className="main-body-top-tab-bar-left-col-a nav-link tab-hover table-refresh"
                      >
                        <span className="main-body-top-tab-bar-left-col-a-text">
                          <img
                            className="tab-hover-img-1"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          <img
                            className="tab-hover-img-2"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          {t("Rework Order")}
                        </span>
                      </Link>
                    </>
                    : (
                      <Link
                        to="/app/inventory/createPOReworkOrder"
                        className="main-body-top-tab-bar-left-col-a nav-link tab-hover table-refresh"
                      >
                        <span className="main-body-top-tab-bar-left-col-a-text">
                          <img
                            className="tab-hover-img-1"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          <img
                            className="tab-hover-img-2"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          {t("Rework Order")}
                        </span>
                      </Link>
                    ) : (
                    <>
                      <Link
                        to="/app/inventory/createpoReplenishOrder"
                        className="main-body-top-tab-bar-left-col-a nav-link tab-hover table-refresh"
                      >
                        <span className="main-body-top-tab-bar-left-col-a-text">
                          <img
                            className="tab-hover-img-1"
                            src={base_url + "images/icons/replenish-icon.png"}
                            alt=""
                          />
                          <img
                            className="tab-hover-img-2"
                            src={base_url + "images/icons/replenish-icon-green.png"}
                            alt=""
                          />
                          {t("Replenish Order")}
                        </span>
                      </Link>
                      <Link
                        to="/app/inventory/createPOReworkOrder"
                        className="main-body-top-tab-bar-left-col-a nav-link tab-hover table-refresh"
                      >
                        <span className="main-body-top-tab-bar-left-col-a-text">
                          <img
                            className="tab-hover-img-1"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          <img
                            className="tab-hover-img-2"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          {t("Rework Order")}
                        </span>
                      </Link>
                    </>
                  )}

                </div>
              </div>
              <div className="tab-content">
                <div className="tab-pane active">
                  <div className="main-body-top-inputs-bar">
                    <div className="main-body-top-inputs-bar-col-left">
                      <label className="po-num-label  po-num-red">{t("po-xxx")}</label>
                      <LocationList
                        setcommanSelected_loc={setcommanSelected_loc}
                        addclass={state?.hidelocationid ? 'row_inactive' : ""} locationid={state ? state?.hidelocationid : ''}
                        commanSelected_vouc={commanSelected_vouc}
                      />
                      <SupplierList
                        setcommanSelected_sup={setcommanSelected_sup}
                      />
                      <TransAndDeliverDate TransactionDate={TransactionDate} DeliveryDate={DeliveryDate} setTransactionDate={setTransactionDate} setDeliveryDate={setDeliveryDate} />
                    </div>
                    <div className="main-body-top-inputs-bar-col-right">
                      <button
                        className="main-body-top-inputs-bar-col-right-submit-btn com-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#createPurchaseModal"
                      >
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                  <div className="main-body-top-status-bar">
                    <Select
                      className=" select-set select p-0 main-content-wrapper-body-top-status-bar-select-num"
                      options={selectOptions}
                      value={{ label: limit, value: limit }}
                      onChange={(e) => setLimit(e.value)}
                      isSearchable={false}
                    />
                    {/* <div className="main-body-top-status-bar-filter">
                      <input
                        type="text"
                        value={filtername}
                        className="main-body-top-status-bar-filter-input"
                        placeholder={t("StockID/SKU")}
                        onKeyPress={(e) => e.key === 'Enter' && filterbyname(e.target.value)}
                        onChange={(e) => setFiltername(e.target.value)}
                      />
                      {filtername ? <img className="main-body-top-status-bar-filter-clear" src={base_assets + 'images/icons/False.png'} onClick={(e) => { setFiltername(""); filterbyname("") }} alt="" /> : ""}
                      <button onClick={() => filterbyname(filtername)} className="main-body-top-status-bar-filter-search">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.9269 14.04L17.4 17.4M16.28 8.43998C16.28 12.7699 12.7699 16.28 8.44001 16.28C4.11009 16.28 0.600006 12.7699 0.600006 8.43998C0.600006 4.11006 4.11009 0.599976 8.44001 0.599976C12.7699 0.599976 16.28 4.11006 16.28 8.43998Z" stroke="#606060" stroke-linecap="round"></path></svg>
                      </button>
                    </div> */}

{ShowProductSearchBar ? (
                          <div className="wrap-expandable-input-field" ref={productSearchBar} style={{
                            marginLeft: "auto",
                            border: "1px solid #e3e3e3",
                            padding: "0 10px",
                            borderRadius: "50px",
                          }}>
                            <div className="main-body-top-status-bar-filter">
                              <button className="main-body-top-status-bar-filter-search" onClick={() => setShowProductSearchBar(false)}>
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.9269 14.04L17.4 17.4M16.28 8.43998C16.28 12.7699 12.7699 16.28 8.44001 16.28C4.11009 16.28 0.600006 12.7699 0.600006 8.43998C0.600006 4.11006 4.11009 0.599976 8.44001 0.599976C12.7699 0.599976 16.28 4.11006 16.28 8.43998Z"
                                    stroke="#606060"
                                    strokeLinecap="round"
                                  />
                                </svg>
                              </button>
                                  <input
                        type="text"
                        value={filtername}
                        className="main-body-top-status-bar-filter-input"
                        placeholder={t("StockID/SKU")}
                        onKeyDown={(e) =>
                          e.key === "Enter" && applySearchNow(e.target.value)
                        }
                        onChange={(e) => handleFilterNameChange(e.target.value)}
                      />
                              {filtername ? <img className="main-body-top-status-bar-filter-clear" src={base_assets + 'images/icons/False.png'} onClick={() => applySearchNow("")} alt="" /> : ""}

                            </div>
                          </div>
                        ) : (
                         <button className="main-body-top-status-bar-filter-search"
                            onClick={() => setShowProductSearchBar(true)}
                          
                          >
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.9269 14.04L17.4 17.4M16.28 8.43998C16.28 12.7699 12.7699 16.28 8.44001 16.28C4.11009 16.28 0.600006 12.7699 0.600006 8.43998C0.600006 4.11006 4.11009 0.599976 8.44001 0.599976C12.7699 0.599976 16.28 4.11006 16.28 8.43998Z"
                                stroke="#606060"
                                strokeLinecap="round"
                              />
                            </svg>
                          </button>
                        )}
                    <div className="main-body-top-status-bar-multi-date-picker" style={{marginLeft:0}}>
                      <button className="print-export-dropdown-selected-icon d-none">
                        <img
                          src={base_url + "images/icons/printer-icon.png"}
                          alt=""
                        />
                      </button>
                      <div className="print-export-dropdown-selected-icon">
                        <button className={
                          selecteditem.length > 0
                            ? "deletebtn btn d-block"
                            : "deletebtn btn d-none"
                        } onClick={deleteProduct}>
                          <svg width="20" height="20" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.43143 4.40639L9.32429 0.834961H14.6814L15.5743 4.40639M22.7171 4.40639H3.07429L4.86 25.835H19.1457L20.9314 4.40639H1.28857H22.7171ZM12.0029 9.76353V20.4778V9.76353ZM16.4671 9.76353L15.5743 20.4778L16.4671 9.76353ZM7.53857 9.76353L8.43143 20.4778L7.53857 9.76353Z" stroke="#5CC7C1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </button>
                      </div>
                      <div
                        className="main-body-top-status-bar-note-button"
                        data-bs-toggle="modal"
                        data-bs-target="#notesModal"
                      >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.83333 7.08333H10M5.83333 10H12.5M5.83333 15V16.9463C5.83333 17.3903 5.83333 17.6123 5.92436 17.7263C6.00352 17.8255 6.12356 17.8832 6.25045 17.8831C6.39636 17.8829 6.56973 17.7442 6.91646 17.4668L8.90434 15.8765C9.31043 15.5517 9.51347 15.3892 9.73957 15.2737C9.94017 15.1712 10.1537 15.0963 10.3743 15.051C10.6231 15 10.8831 15 11.4031 15H13.5C14.9001 15 15.6002 15 16.135 14.7275C16.6054 14.4878 16.9878 14.1054 17.2275 13.635C17.5 13.1002 17.5 12.4001 17.5 11V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V11.6667C2.5 12.4416 2.5 12.8291 2.58519 13.147C2.81635 14.0098 3.49022 14.6836 4.35295 14.9148C4.67087 15 5.05836 15 5.83333 15Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        {t("note")}
                      </div>
                      <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{width:'20px',marginLeft:'-8px'}}
                        >
                          <svg width="4" height="10" viewBox="0 0 4 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 10C1.30964 10 0.75 9.44036 0.75 8.75C0.75 8.05964 1.30964 7.5 2 7.5C2.69036 7.5 3.25 8.05964 3.25 8.75C3.25 9.44036 2.69036 10 2 10ZM2 6.25C1.30964 6.25 0.75 5.69036 0.75 5C0.75 4.30964 1.30964 3.75 2 3.75C2.69036 3.75 3.25 4.30964 3.25 5C3.25 5.33152 3.1183 5.64946 2.88388 5.88388C2.64946 6.1183 2.33152 6.25 2 6.25ZM2 2.5C1.30964 2.5 0.75 1.94036 0.75 1.25C0.75 0.559644 1.30964 0 2 0C2.69036 0 3.25 0.559644 3.25 1.25C3.25 1.58152 3.1183 1.89946 2.88388 2.13388C2.64946 2.3683 2.33152 2.5 2 2.5Z" fill="#2A2A2A"></path></svg>
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#posOrderByLocationExportFormatModal"
                          >
                            <div className="dropdown-item-img">
                              <img
                                src={
                                  base_url + "images/icons/export-x-icon.png"
                                }
                                alt=""
                              />
                            </div>
                            <span>{t("export")}</span>
                          </li>
                          <li
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#columnModal"
                          >
                            <div className="dropdown-item-img">
                              <img
                                src={base_url + "images/icons/column-icon.png"}
                                alt=""
                              />
                            </div>
                            <span>{t("column")}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div className="container" id="style-create-po-page-body">
          <div className="row">
            <div className="col-lg-12">
              <div className="tab-content">
                <div id="pos_order" className="tab-pane active">
                  <div className="common-sub-table-wrap add-row position-relative overflow-auto">
                    <div className="main-body-main-table-wrap">
                      <table
                        id="tbl_pos_order_table"
                        className="common-table product-base-table w-100"
                      >
                        <thead>
                          <tr>
                            {newcolumndata?.map((col, index) => {
                              if (!col?.status) return null;
                              if (col.name === "check_box") {
                                return (
                                  <th key={index}>
                                    <div className="com-check">
                                      <input
                                        id="th_comman_checkbox"
                                        onClick={handleSelectAllCheckBox}
                                        className={col.class}
                                        type="checkbox"
                                      />
                                      <label
                                        htmlFor="th_comman_checkbox"
                                        className="com-check-label"
                                      />
                                    </div>
                                  </th>
                                );
                              }
                              const sortKey = SORT_KEYS[index];
                              const active = sortConfig.key === sortKey;
                              return (
                                <th
                                  key={index}
                                  className={col.class}
                                  onClick={sortKey ? () => handleSort(sortKey) : undefined}
                                  style={sortKey ? { cursor: "pointer" } : undefined}
                                >
                                  {t(col.lable)}
                                  {sortKey ? (
                                    <div className="up-down-arrow-btn">
                                      <img
                                        className={
                                          "up-down-arrow-img up-down-arrow-img-forward" +
                                          (active && sortConfig.direction === "desc" ? "" : " active")
                                        }
                                        src={base_url + "images/icons/up-down-arrow.png"}
                                        alt=""
                                      />
                                      <img
                                        className={
                                          "up-down-arrow-img up-down-arrow-img-reverse" +
                                          (active && sortConfig.direction === "desc" ? " active" : "")
                                        }
                                        src={base_url + "images/icons/up-down-arrow-reverse.png"}
                                        alt=""
                                      />
                                    </div>
                                  ) : null}
                                </th>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {sortedList?.map((result, index) => {
                            return (
                              <tr key={index}>
                                {newcolumndata[0]?.status && (
                                <td>
                                  <div className="com-check ">
                                    <input
                                      id={"po_create_" + index}
                                      type="checkbox"
                                      data-key={index}
                                      onChange={selectedproduct}
                                      data-id={result?.id}
                                      value={result?.pos?.cart_id}
                                      className="PO_OrdersList posordertableHead"
                                    />
                                    <label
                                      htmlFor={"po_create_" + index}
                                      className="com-check-label"
                                    />
                                  </div>
                                </td>
                                )}
                                {newcolumndata[1]?.status && (
                                <td>{index + 1}</td>
                                )}
                                {newcolumndata[2]?.status && (
                                <td>
                                  <div className="table-pro-img">
                                    <img
                                      src={result?.product_details?.main_image}
                                      alt=""
                                    />
                                  </div>
                                </td>
                                )}
                                {newcolumndata[3]?.status && (
                                <td className="po-no">
                                  {result?.product_details?.SKU}
                                </td>
                                )}
                                {newcolumndata[4]?.status && (
                                <td> {result?.createdAt}</td>
                                )}
                                {newcolumndata[5]?.status && (
                                <td className="po-no danger-text cursor-ponter">
                                  {result.pos.ref}
                                </td>
                                )}
                                {newcolumndata[6]?.status && (
                                <td className="col-highlight">{result?.stock_id}</td>
                                )}
                                {newcolumndata[7]?.status && (
                                <td className="col-highlight">
                                  {result?.product_details?.metal_name}
                                </td>
                                )}
                                {newcolumndata[8]?.status && (
                                <td className="col-highlight">
                                  {result?.product_details?.stone_name}
                                </td>
                                )}
                                {newcolumndata[9]?.status && (
                                <td className="col-highlight">
                                  {result?.product_details?.size_name}
                                </td>
                                )}
                                {newcolumndata[10]?.status && (
                                state?.createlist ?
                                  <td className="col-highlight">
                                    {result?.Qty}
                                  </td> :
                                  <td className="col-highlight">
                                    <div className="col-input">
                                      <input
                                        type="text"
                                        onChange={(e) =>
                                          mapChange_handle(
                                            index,
                                            e.target.value,
                                            "Qty"
                                          )
                                        }
                                        name="Qty"
                                        defaultValue={result.Qty}
                                      />
                                    </div>
                                  </td>
                                )}
                                {newcolumndata[11]?.status && (
                                <td className="col-highlight">
                                  <div className="col-input">
                                    <input
                                      className="col-width"
                                      type="text"
                                      name="price"
                                      onChange={(e) =>
                                        mapChange_handle(
                                          index,
                                          e.target.value,
                                          "price"
                                        )
                                      }
                                      defaultValue={toFormatPrice(result.price)}
                                    />
                                  </div>
                                </td>
                                )}
                                {newcolumndata[12]?.status && (
                                <td className="col-highlight">
                                  {" "}
                                  {toFormatPrice(
                                    parseInt(result.Qty) *
                                    parseFloat(toUnformatPrice(result.price, { addSymbol: true }))
                                  )}
                                </td>
                                )}
                                {newcolumndata[13]?.status && (
                                <td className="danger-text col-highlight">
                                  {result.location_name}
                                </td>
                                )}
                                {newcolumndata[14]?.status && (
                                <td className="danger-text col-highlight">
                                  {result.customer_name}
                                </td>
                                )}
                                {newcolumndata[15]?.status && (
                                <td className="danger-text col-highlight">
                                  {result.delivery_date}
                                </td>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            {newcolumndata[0]?.status && (
                            <td className="main-green-text left-0" />
                            )}
                            {newcolumndata[1]?.status && <td />}
                            {newcolumndata[2]?.status && <td />}
                            {newcolumndata[3]?.status && <td />}
                            {newcolumndata[4]?.status && <td />}
                            {newcolumndata[5]?.status && <td />}
                            {newcolumndata[6]?.status && <td />}
                            {newcolumndata[7]?.status && <td />}
                            {newcolumndata[8]?.status && <td />}
                            {newcolumndata[9]?.status && <td />}
                            {newcolumndata[10]?.status && (
                            <td>
                              {PO_OrdersList?.reduce(
                                (a, v) => (a = a + parseInt(v.Qty)),
                                0
                              )}
                            </td>
                            )}
                            {newcolumndata[11]?.status && <td />}
                            {newcolumndata[12]?.status && (
                            <td>
                              {toFormatPrice(
                                PO_OrdersList?.reduce(
                                  (a, v) =>
                                  (a =
                                    a +
                                    parseInt(v.Qty) *
                                    parseFloat(toUnformatPrice(v.price))),
                                  0
                                )
                                , { addSymbol: true })}
                            </td>
                            )}
                            {newcolumndata[13]?.status && <td />}
                            {newcolumndata[14]?.status && <td />}
                            {newcolumndata[15]?.status && <td />}
                          </tr>
                        </tfoot>
                      </table>
                      {selecteditem.length > 0 ? (
                        <div className="replenish-selected-count">
                          {selecteditem.length} {t("item selected")}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SocialModal />
      </div>
      <TableColumnModal
        tablehead={createpotablehead}
        tblName={"tbl_po_createpo"}
        setnewcolumndata={setnewcolumndata}
        calldatatable={posorders_idshave}
      ></TableColumnModal>
      <ConfirmationModel statement={t("Create Purchase Order")} handler_submit={po_create_submit}></ConfirmationModel>
      <div
        className="modal fade common-modal"
        id="posOrderByLocationExportFormatModal"
        tabIndex={-1}
        aria-labelledby="posOrderByLocationExportFormatModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_url + "images/icons/exclamation-mark-green.png"}
                alt=""
              />
              <p className="modal-content-text mb-2">{t("Export format")}</p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="posOrderByLocationExportFormat"
                    value="xlsx"
                    checked={poExportFormat === "xlsx"}
                    onChange={() => setPoExportFormat("xlsx")}
                  />
                  {t("Excel (.xlsx)")}
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="posOrderByLocationExportFormat"
                    value="csv"
                    checked={poExportFormat === "csv"}
                    onChange={() => setPoExportFormat("csv")}
                  />
                  {t("CSV")}
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-yes"
                data-bs-dismiss="modal"
                onClick={() => downloadexclsheet(poExportFormat)}
              >
                {t("Export")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <NotesModalLabel setForm_note={setForm_note}></NotesModalLabel>
      <Advancedfiltermodel></Advancedfiltermodel>
    </React.Fragment>
  );
};
export default CreatePO;
